import React, { Component } from 'react';
import './Documentation.css';

class Documentation extends Component {
    render() {
        return <div className="Documentation">
        <iframe src="/apib/Documentation.html" title="API Documentation" ></iframe>
        </div>;
    }
}

/*
class Documentation extends Component {
    constructor() {
        super();
        
        this.state = {
            iFrameHeight: '0px'
        }
    }
    
    render() {
        return <div className="Documentation">
        <iframe id="documentationIframe" src="/apib/Documentation.html" style={{height:this.state.iFrameHeight}} 
        title="API Documentation" onLoad={() => this.adjustIframe()} ></iframe>
        </div>;
    }
    
    adjustIframe() {
        this.setState({
            "iFrameHeight":  (document.getElementById("documentationIframe").contentWindow.document.body.scrollHeight + 30) + 'px'
        });
    }
}
*/

export default Documentation;
